import React from 'react';

export interface FooterProps {
  phone?: string;
  email?: string;
  address?: string;
  openingHours?: { day: string; hours: string }[];
}

/**
 * Footer component — minimal version with logo text, tagline, legal link and copyright.
 */
export const Footer: React.FC<FooterProps> = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black/85 text-gray-300 py-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">

          {/* Restaurant name + tagline */}
          <div className="text-center sm:text-left">
            <p className="text-[#c9a84c] font-semibold">Fey am Tibarg</p>
            <p className="text-sm text-gray-500">Mediterran inspirierte Küche am Tibarg, Hamburg</p>
          </div>

          {/* Legal link */}
          <nav aria-label="Rechtliche Links">
            <a
              href="#impressum"
              className="text-sm text-gray-400 hover:text-[#c9a84c] transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a84c] rounded"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('impressum')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              Impressum
            </a>
          </nav>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t border-gray-800 text-center text-sm text-gray-500">
          <p>&copy; {currentYear} Fey am Tibarg. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};
